import React, { useMemo, useState } from "react";

const RelatorioFolhaRH = () => {
  const [selectedMonth] = useState("");
  const [selectedCostCenter, setSelectedCostCenter] = useState("");
  const [drillDownCenter, setDrillDownCenter] = useState(null);
  const [mesAMesExpandido, setMesAMesExpandido] = useState(false);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [itensPorPagina, setItensPorPagina] = useState(10);

  // Dados simulados
  const dadosRH = {
    funcionarios: {
      orcado: 450,
      realizado: 432,
    },
    folhaTotal: {
      orcado: 2850000,
      realizado: 2735000,
    },
    realizadoMensal: [
      { mes: "Janeiro", codigo: "01.2024", valor: 245000, percentual: 96.0 },
      { mes: "Fevereiro", codigo: "02.2024", valor: 238000, percentual: 93.3 },
      { mes: "Março", codigo: "03.2024", valor: 252000, percentual: 98.8 },
      { mes: "Abril", codigo: "04.2024", valor: 248000, percentual: 97.2 },
      { mes: "Maio", codigo: "05.2024", valor: 255000, percentual: 100.0 },
      { mes: "Junho", codigo: "06.2024", valor: 251000, percentual: 98.4 },
      { mes: "Julho", codigo: "07.2024", valor: 258000, percentual: 101.2 },
      { mes: "Agosto", codigo: "08.2024", valor: 262000, percentual: 102.7 },
      { mes: "Setembro", codigo: "09.2024", valor: 259000, percentual: 101.6 },
      { mes: "Outubro", codigo: "10.2024", valor: 264000, percentual: 103.5 },
      { mes: "Novembro", codigo: "11.2024", valor: 268000, percentual: 105.1 },
      { mes: "Dezembro", codigo: "12.2024", valor: 275000, percentual: 107.8 },
    ],
    centrosCusto: [
      {
        nome: "ADMINISTRAÇÃO E MANUTENÇÃO",
        codigo: "4.01.02.001.001",
        tipo: "D",
        orcado: 850000,
        realizadoSalario: 620000,
        realizadoEncargos: 186000,
        realizadoBeneficios: 124000,
        funcionarios: [
          {
            nome: "João Silva",
            cargo: "Gerente Administrativo",
            salario: 12000,
            encargos: 3600,
            beneficios: 2400,
          },
          {
            nome: "Maria Santos",
            cargo: "Assistente Administrativo",
            salario: 4500,
            encargos: 1350,
            beneficios: 900,
          },
          {
            nome: "Pedro Oliveira",
            cargo: "Analista RH",
            salario: 7000,
            encargos: 2100,
            beneficios: 1400,
          },
          {
            nome: "Ana Costa",
            cargo: "Auxiliar Administrativo",
            salario: 3200,
            encargos: 960,
            beneficios: 640,
          },
          {
            nome: "Carlos Mendes",
            cargo: "Coordenador RH",
            salario: 8500,
            encargos: 2550,
            beneficios: 1700,
          },
        ],
      },
      {
        nome: "PRODUÇÃO E OPERAÇÕES",
        codigo: "4.01.02.001.002",
        tipo: "D",
        orcado: 1200000,
        realizadoSalario: 890000,
        realizadoEncargos: 267000,
        realizadoBeneficios: 178000,
        funcionarios: [
          {
            nome: "Roberto Lima",
            cargo: "Supervisor Produção",
            salario: 9000,
            encargos: 2700,
            beneficios: 1800,
          },
          {
            nome: "Fernanda Rocha",
            cargo: "Operadora Linha 1",
            salario: 3800,
            encargos: 1140,
            beneficios: 760,
          },
          {
            nome: "José Ferreira",
            cargo: "Técnico Manutenção",
            salario: 5500,
            encargos: 1650,
            beneficios: 1100,
          },
          {
            nome: "Luciana Pereira",
            cargo: "Operadora Linha 2",
            salario: 3600,
            encargos: 1080,
            beneficios: 720,
          },
          {
            nome: "Ricardo Silva",
            cargo: "Encarregado Produção",
            salario: 7500,
            encargos: 2250,
            beneficios: 1500,
          },
        ],
      },
      {
        nome: "VENDAS E MARKETING",
        codigo: "4.01.02.001.003",
        tipo: "D",
        orcado: 650000,
        realizadoSalario: 480000,
        realizadoEncargos: 144000,
        realizadoBeneficios: 96000,
        funcionarios: [
          {
            nome: "Bruno Santos",
            cargo: "Gerente Vendas",
            salario: 11000,
            encargos: 3300,
            beneficios: 2200,
          },
          {
            nome: "Camila Oliveira",
            cargo: "Vendedor Sênior",
            salario: 5000,
            encargos: 1500,
            beneficios: 1000,
          },
          {
            nome: "Diego Costa",
            cargo: "Representante Comercial",
            salario: 4200,
            encargos: 1260,
            beneficios: 840,
          },
          {
            nome: "Elena Ferreira",
            cargo: "Analista Marketing",
            salario: 6500,
            encargos: 1950,
            beneficios: 1300,
          },
        ],
      },
      {
        nome: "TECNOLOGIA DA INFORMAÇÃO",
        codigo: "4.01.02.001.004",
        tipo: "D",
        orcado: 480000,
        realizadoSalario: 365000,
        realizadoEncargos: 109500,
        realizadoBeneficios: 73000,
        funcionarios: [
          {
            nome: "Felipe Tech",
            cargo: "Desenvolvedor Senior",
            salario: 13000,
            encargos: 3900,
            beneficios: 2600,
          },
          {
            nome: "Gabriela Code",
            cargo: "Analista Sistemas",
            salario: 8500,
            encargos: 2550,
            beneficios: 1700,
          },
          {
            nome: "Hugo Data",
            cargo: "DBA",
            salario: 10000,
            encargos: 3000,
            beneficios: 2000,
          },
          {
            nome: "Isabela Cyber",
            cargo: "Analista Segurança",
            salario: 9500,
            encargos: 2850,
            beneficios: 1900,
          },
        ],
      },
      {
        nome: "FINANCEIRO E CONTABILIDADE",
        codigo: "4.01.02.001.005",
        tipo: "D",
        orcado: 420000,
        realizadoSalario: 310000,
        realizadoEncargos: 93000,
        realizadoBeneficios: 62000,
        funcionarios: [
          {
            nome: "Sandra Fiscal",
            cargo: "Contador",
            salario: 9000,
            encargos: 2700,
            beneficios: 1800,
          },
          {
            nome: "Marcos Contas",
            cargo: "Assistente Financeiro",
            salario: 4500,
            encargos: 1350,
            beneficios: 900,
          },
        ],
      },
      {
        nome: "LOGÍSTICA E ALMOXARIFADO",
        codigo: "4.01.02.001.006",
        tipo: "D",
        orcado: 380000,
        realizadoSalario: 280000,
        realizadoEncargos: 84000,
        realizadoBeneficios: 56000,
        funcionarios: [
          {
            nome: "Paulo Estoque",
            cargo: "Supervisor Logística",
            salario: 7500,
            encargos: 2250,
            beneficios: 1500,
          },
          {
            nome: "Carla Almox",
            cargo: "Almoxarife",
            salario: 4000,
            encargos: 1200,
            beneficios: 800,
          },
        ],
      },
      {
        nome: "QUALIDADE E CONTROLE",
        codigo: "4.01.02.001.007",
        tipo: "D",
        orcado: 320000,
        realizadoSalario: 240000,
        realizadoEncargos: 72000,
        realizadoBeneficios: 48000,
        funcionarios: [
          {
            nome: "Rita Qualidade",
            cargo: "Analista Qualidade",
            salario: 6500,
            encargos: 1950,
            beneficios: 1300,
          },
          {
            nome: "João Controle",
            cargo: "Inspetor",
            salario: 4500,
            encargos: 1350,
            beneficios: 900,
          },
        ],
      },
      {
        nome: "SEGURANÇA DO TRABALHO",
        codigo: "4.01.02.001.008",
        tipo: "D",
        orcado: 280000,
        realizadoSalario: 210000,
        realizadoEncargos: 63000,
        realizadoBeneficios: 42000,
        funcionarios: [
          {
            nome: "Carlos Segurança",
            cargo: "Técnico Segurança",
            salario: 5500,
            encargos: 1650,
            beneficios: 1100,
          },
          {
            nome: "Ana CIPA",
            cargo: "Auxiliar SESMT",
            salario: 3500,
            encargos: 1050,
            beneficios: 700,
          },
        ],
      },
      {
        nome: "MANUTENÇÃO PREDIAL",
        codigo: "4.01.02.001.009",
        tipo: "D",
        orcado: 250000,
        realizadoSalario: 185000,
        realizadoEncargos: 55500,
        realizadoBeneficios: 37000,
        funcionarios: [
          {
            nome: "Roberto Manutenção",
            cargo: "Eletricista",
            salario: 4800,
            encargos: 1440,
            beneficios: 960,
          },
          {
            nome: "José Predial",
            cargo: "Auxiliar Manutenção",
            salario: 3200,
            encargos: 960,
            beneficios: 640,
          },
        ],
      },
      {
        nome: "TRANSPORTE E FROTA",
        codigo: "4.01.02.001.010",
        tipo: "D",
        orcado: 200000,
        realizadoSalario: 150000,
        realizadoEncargos: 45000,
        realizadoBeneficios: 30000,
        funcionarios: [
          {
            nome: "Pedro Motorista",
            cargo: "Motorista",
            salario: 3800,
            encargos: 1140,
            beneficios: 760,
          },
          {
            nome: "Luis Frota",
            cargo: "Mecânico",
            salario: 4200,
            encargos: 1260,
            beneficios: 840,
          },
        ],
      },
      {
        nome: "COMPRAS E SUPRIMENTOS",
        codigo: "4.01.02.001.011",
        tipo: "D",
        orcado: 180000,
        realizadoSalario: 135000,
        realizadoEncargos: 40500,
        realizadoBeneficios: 27000,
        funcionarios: [
          {
            nome: "Maria Compras",
            cargo: "Compradora",
            salario: 5500,
            encargos: 1650,
            beneficios: 1100,
          },
          {
            nome: "João Suprimentos",
            cargo: "Auxiliar Compras",
            salario: 3000,
            encargos: 900,
            beneficios: 600,
          },
        ],
      },
      {
        nome: "JURÍDICO E COMPLIANCE",
        codigo: "4.01.02.001.012",
        tipo: "D",
        orcado: 350000,
        realizadoSalario: 260000,
        realizadoEncargos: 78000,
        realizadoBeneficios: 52000,
        funcionarios: [
          {
            nome: "Dra. Ana Direito",
            cargo: "Advogada",
            salario: 12000,
            encargos: 3600,
            beneficios: 2400,
          },
          {
            nome: "Carlos Compliance",
            cargo: "Analista Compliance",
            salario: 7000,
            encargos: 2100,
            beneficios: 1400,
          },
        ],
      },
    ],
  };

  const calcularPercentualExecucao = (orcado, realizado) => {
    return (realizado / orcado) * 100;
  };

  const getCorPercentual = (percentual) => {
    if (percentual <= 85) return "badge bg-success";
    if (percentual <= 100) return "badge bg-warning";
    return "badge bg-danger";
  };

  const getStatusTexto = (percentual) => {
    if (percentual <= 85) return "BOM";
    if (percentual <= 100) return "MÉDIO";
    return "ALTO";
  };

  const centrosFiltrados = useMemo(() => {
    let centros = dadosRH.centrosCusto;

    if (selectedCostCenter) {
      centros = centros.filter((centro) =>
        centro.nome.toLowerCase().includes(selectedCostCenter.toLowerCase())
      );
    }

    return centros.map((centro) => {
      const totalRealizado =
        centro.realizadoSalario +
        centro.realizadoEncargos +
        centro.realizadoBeneficios;
      const percentualExecucao = calcularPercentualExecucao(
        centro.orcado,
        totalRealizado
      );
      const disponivel = centro.orcado - totalRealizado;

      return {
        ...centro,
        totalRealizado,
        percentualExecucao,
        disponivel,
      };
    });
  }, [selectedCostCenter, dadosRH.centrosCusto]);

  const centrosPaginados = useMemo(() => {
    const inicio = (paginaAtual - 1) * itensPorPagina;
    const fim = inicio + itensPorPagina;
    return centrosFiltrados.slice(inicio, fim);
  }, [centrosFiltrados, paginaAtual, itensPorPagina]);

  const totalPaginas = Math.ceil(centrosFiltrados.length / itensPorPagina);

  const dadosMensaisFiltrados = useMemo(() => {
    let dados = dadosRH.realizadoMensal;

    if (selectedMonth) {
      dados = dados.filter((item) => item.mes === selectedMonth);
    }

    // Calcular valores acumulados
    let acumulado = 0;
    return dados.map((item) => {
      acumulado += item.valor;
      return {
        ...item,
        acumulado,
      };
    });
  }, [selectedMonth, dadosRH.realizadoMensal]);

  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor);
  };

  if (drillDownCenter) {
    return (
      <div className="min-vh-100" style={{ backgroundColor: "#f8f9fa" }}>
        {/* Header Azul */}
        <div className="bg-primary text-white p-4">
          <div className="container">
            <h1 className="h2 mb-2 fw-bold">
              RELATÓRIO ANALÍTICO - FOLHA DE PAGAMENTO
            </h1>
            <p className="mb-1 opacity-75">
              Detalhamento de Funcionários por Centro de Custo com Drill-down
            </p>
            <small className="opacity-50">
              Período: Janeiro a Junho de 2025 | Gerado em: 17/06/2025
            </small>
          </div>
        </div>

        <div className="container py-4">
          {/* Navegação */}
          <div className="card shadow-sm mb-4">
            <div className="card-body">
              <button
                onClick={() => setDrillDownCenter(null)}
                className="btn btn-link text-primary p-0 text-decoration-none"
              >
                <span className="me-2">←</span>
                <span>Voltar ao Relatório Principal</span>
              </button>
            </div>
          </div>

          {/* Header do Centro de Custo */}
          <div className="card shadow-sm">
            <div className="card-header bg-primary text-white">
              <h4 className="mb-0">
                📋 DETALHAMENTO DE FUNCIONÁRIOS - {drillDownCenter.nome}
              </h4>
            </div>

            {/* Tabela de Funcionários */}
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-striped mb-0">
                  <thead className="table-dark">
                    <tr>
                      <th>FUNCIONÁRIO</th>
                      <th>CARGO</th>
                      <th className="text-end">SALÁRIO (R$)</th>
                      <th className="text-end">ENCARGOS (R$)</th>
                      <th className="text-end">BENEFÍCIOS (R$)</th>
                      <th className="text-end">TOTAL (R$)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {drillDownCenter.funcionarios.map((funcionario, index) => {
                      const total =
                        funcionario.salario +
                        funcionario.encargos +
                        funcionario.beneficios;
                      return (
                        <tr key={index}>
                          <td className="fw-semibold">{funcionario.nome}</td>
                          <td>{funcionario.cargo}</td>
                          <td className="text-end font-monospace">
                            {formatarMoeda(funcionario.salario)}
                          </td>
                          <td className="text-end font-monospace">
                            {formatarMoeda(funcionario.encargos)}
                          </td>
                          <td className="text-end font-monospace">
                            {formatarMoeda(funcionario.beneficios)}
                          </td>
                          <td className="text-end font-monospace fw-bold">
                            {formatarMoeda(total)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot className="table-secondary">
                    <tr>
                      <td colSpan="2" className="fw-bold">
                        TOTAL DO CENTRO DE CUSTO
                      </td>
                      <td className="text-end font-monospace fw-bold">
                        {formatarMoeda(drillDownCenter.realizadoSalario)}
                      </td>
                      <td className="text-end font-monospace fw-bold">
                        {formatarMoeda(drillDownCenter.realizadoEncargos)}
                      </td>
                      <td className="text-end font-monospace fw-bold">
                        {formatarMoeda(drillDownCenter.realizadoBeneficios)}
                      </td>
                      <td className="text-end font-monospace fw-bold">
                        {formatarMoeda(drillDownCenter.totalRealizado)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#f8f9fa" }}>
      {/* Header Azul */}
      <div className="bg-primary text-white p-4">
        <div className="container">
          <h1 className="h2 mb-2 fw-bold">
            RELATÓRIO ANALÍTICO - FOLHA DE PAGAMENTO
          </h1>
          <p className="mb-1 opacity-75">
            Demonstrativo Detalhado por Centro de Custo e Natureza com
            Drill-down por Funcionário
          </p>
          <small className="opacity-50">
            Período: Janeiro a Junho de 2025 | Gerado em: 17/06/2025
          </small>
        </div>
      </div>

      <div className="container py-4">
        {/* Filtros */}
        <div
          className="card shadow-sm mb-4"
          style={{ backgroundColor: "#e9ecef" }}
        >
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center">
                <span className="me-2">🔍</span>
                <span className="fw-semibold">Filtros</span>
              </div>
              <button className="btn btn-danger btn-sm">
                <span className="me-1">📄</span>
                Exportar PDF
              </button>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label fw-semibold">
                  Filtrar por Tipo:
                </label>
                <select className="form-select">
                  <option>Todos os Tipos</option>
                  <option>Despesa</option>
                  <option>Receita</option>
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label fw-semibold">
                  Filtrar por Centro:
                </label>
                <select
                  value={selectedCostCenter}
                  onChange={(e) => setSelectedCostCenter(e.target.value)}
                  className="form-select"
                >
                  <option value="">Todos os Centros</option>
                  {dadosRH.centrosCusto.map((centro, index) => (
                    <option key={index} value={centro.nome}>
                      {centro.nome}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">&nbsp;</label>
                <button className="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center">
                  <span className="me-1">🗑️</span>
                  Limpar Filtros
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Resumo Executivo */}
        <div
          className="card shadow-sm mb-4"
          style={{ backgroundColor: "#e9ecef" }}
        >
          <div className="card-body">
            <div className="d-flex align-items-center mb-3">
              <div
                className="me-2"
                style={{
                  width: "16px",
                  height: "16px",
                  background: "linear-gradient(45deg, #007bff, #0056b3)",
                  borderRadius: "2px",
                }}
              ></div>
              <span className="fw-semibold">Resumo Executivo</span>
            </div>

            <div className="row g-3">
              <div className="col-md-4">
                <div className="card shadow-sm h-100">
                  <div className="card-body">
                    <small className="text-muted d-block mb-1">
                      TOTAL ORÇADO
                    </small>
                    <h4 className="text-primary fw-bold mb-0">
                      {formatarMoeda(dadosRH.folhaTotal.orcado)}
                    </h4>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card shadow-sm h-100">
                  <div className="card-body">
                    <small className="text-muted d-block mb-1">
                      TOTAL REALIZADO
                    </small>
                    <h4 className="text-primary fw-bold mb-1">
                      {formatarMoeda(dadosRH.folhaTotal.realizado)}
                    </h4>
                    <small className="text-success">
                      {(
                        (dadosRH.folhaTotal.realizado /
                          dadosRH.folhaTotal.orcado) *
                        100
                      ).toFixed(1)}
                      % do orçado
                    </small>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="card shadow-sm h-100">
                  <div className="card-body">
                    <small className="text-muted d-block mb-1">
                      SALDO DISPONÍVEL
                    </small>
                    <h4 className="text-primary fw-bold mb-1">
                      {formatarMoeda(
                        dadosRH.folhaTotal.orcado - dadosRH.folhaTotal.realizado
                      )}
                    </h4>
                    <small className="text-success">
                      {(
                        ((dadosRH.folhaTotal.orcado -
                          dadosRH.folhaTotal.realizado) /
                          dadosRH.folhaTotal.orcado) *
                        100
                      ).toFixed(1)}
                      % do orçado
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Informação sobre drill-down */}
        <div className="alert alert-info border-start border-primary border-4 mb-4">
          <div className="row">
            <div className="col-md-6">
              <strong>💡 Dica:</strong> Clique sobre os valores na coluna
              "REALIZADO (R$)" para ver o detalhamento dos funcionários que
              compõem o valor.
            </div>
            <div className="col-md-6">
              <strong>🔽 Navegação:</strong> Clique no cabeçalho "MÊS A MÊS"
              para expandir/colapsar e otimizar o espaço para seus{" "}
              {dadosRH.centrosCusto.length} centros de custo.
            </div>
          </div>
        </div>

        {/* Total Realizado Mês a Mês - TABELA */}
        <div className="card shadow-sm mb-4">
          <div
            className="card-header bg-primary text-white d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
            onClick={() => setMesAMesExpandido(!mesAMesExpandido)}
          >
            <h5 className="mb-0">📊 TOTAL REALIZADO MÊS A MÊS - ANALÍTICO</h5>
            <button
              className="btn btn-link text-white p-0 text-decoration-none"
              type="button"
            >
              <span style={{ fontSize: "1.2rem" }}>
                {mesAMesExpandido ? "🔼" : "🔽"}
              </span>
            </button>
          </div>

          {mesAMesExpandido && (
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-striped mb-0">
                  <thead className="table-dark">
                    <tr>
                      <th>MÊS</th>
                      <th>CÓDIGO</th>
                      <th className="text-end">REALIZADO (R$)</th>
                      <th className="text-end">ACUMULADO (R$)</th>
                      <th className="text-center">% EXEC.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dadosMensaisFiltrados.map((item, index) => (
                      <tr key={index}>
                        <td className="fw-semibold">{item.mes}</td>
                        <td>{item.codigo}</td>
                        <td className="text-end font-monospace">
                          {formatarMoeda(item.valor)}
                        </td>
                        <td className="text-end font-monospace fw-bold text-primary">
                          {formatarMoeda(item.acumulado)}
                        </td>
                        <td className="text-center">
                          {item.percentual.toFixed(1)}%
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {!mesAMesExpandido && (
            <div className="card-body text-center text-muted py-2">
              <small>
                Clique no cabeçalho para expandir e ver os dados mensais
              </small>
            </div>
          )}
        </div>

        {/* Detalhamento por Centro de Custo */}
        <div className="card shadow-sm">
          <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
            <h5 className="mb-0">
              📋 DETALHAMENTO POR CENTRO DE CUSTO E NATUREZA - ANALÍTICO
            </h5>
            <div className="d-flex align-items-center gap-3">
              <select
                className="form-select form-select-sm text-dark"
                value={itensPorPagina}
                onChange={(e) => {
                  setItensPorPagina(Number(e.target.value));
                  setPaginaAtual(1);
                }}
                style={{ width: "auto" }}
              >
                <option value={5}>5 por página</option>
                <option value={10}>10 por página</option>
                <option value={20}>20 por página</option>
                <option value={50}>50 por página</option>
              </select>
              <span className="badge bg-light text-primary">
                {centrosFiltrados.length}{" "}
                {centrosFiltrados.length === 1 ? "Centro" : "Centros"}
              </span>
            </div>
          </div>

          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-striped mb-0">
                <thead className="table-dark">
                  <tr>
                    <th>CENTRO DE CUSTO / NATUREZA</th>
                    <th className="text-center">CÓDIGO</th>
                    <th className="text-center">TIPO</th>
                    <th className="text-end">ORÇADO (R$)</th>
                    <th className="text-end">REALIZADO (R$)</th>
                    <th className="text-end">DISPONÍVEL (R$)</th>
                    <th className="text-center">% EXEC.</th>
                    <th className="text-center">STATUS</th>
                  </tr>
                </thead>
                <tbody>
                  {centrosPaginados.map((centro, index) => (
                    <tr key={index}>
                      <td className="fw-semibold">{centro.nome}</td>
                      <td className="text-center">{centro.codigo}</td>
                      <td className="text-center">
                        <span className="badge bg-secondary">
                          {centro.tipo}
                        </span>
                      </td>
                      <td className="text-end font-monospace">
                        {formatarMoeda(centro.orcado)}
                      </td>
                      <td className="text-end font-monospace">
                        <button
                          onClick={() => setDrillDownCenter(centro)}
                          className="btn btn-link text-primary p-0 text-decoration-none fw-semibold"
                        >
                          {formatarMoeda(centro.totalRealizado)} 🔍
                        </button>
                      </td>
                      <td className="text-end font-monospace">
                        {formatarMoeda(centro.disponivel)}
                      </td>
                      <td className="text-center">
                        {centro.percentualExecucao.toFixed(1)}%
                      </td>
                      <td className="text-center">
                        <span
                          className={getCorPercentual(
                            centro.percentualExecucao
                          )}
                        >
                          {getStatusTexto(centro.percentualExecucao)}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Paginação */}
          {totalPaginas > 1 && (
            <div className="card-footer bg-light">
              <div className="d-flex justify-content-between align-items-center">
                <div className="text-muted">
                  Mostrando {(paginaAtual - 1) * itensPorPagina + 1} a{" "}
                  {Math.min(
                    paginaAtual * itensPorPagina,
                    centrosFiltrados.length
                  )}{" "}
                  de {centrosFiltrados.length} centros
                </div>
                <nav>
                  <ul className="pagination pagination-sm mb-0">
                    <li
                      className={`page-item ${
                        paginaAtual === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setPaginaAtual(paginaAtual - 1)}
                        disabled={paginaAtual === 1}
                      >
                        Anterior
                      </button>
                    </li>

                    {[...Array(totalPaginas)].map((_, index) => {
                      const numeroPagina = index + 1;
                      if (
                        numeroPagina === 1 ||
                        numeroPagina === totalPaginas ||
                        (numeroPagina >= paginaAtual - 1 &&
                          numeroPagina <= paginaAtual + 1)
                      ) {
                        return (
                          <li
                            key={numeroPagina}
                            className={`page-item ${
                              paginaAtual === numeroPagina ? "active" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setPaginaAtual(numeroPagina)}
                            >
                              {numeroPagina}
                            </button>
                          </li>
                        );
                      } else if (
                        numeroPagina === paginaAtual - 2 ||
                        numeroPagina === paginaAtual + 2
                      ) {
                        return (
                          <li key={numeroPagina} className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        );
                      }
                      return null;
                    })}

                    <li
                      className={`page-item ${
                        paginaAtual === totalPaginas ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setPaginaAtual(paginaAtual + 1)}
                        disabled={paginaAtual === totalPaginas}
                      >
                        Próximo
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RelatorioFolhaRH;
